// @ts-nocheck
import _ from 'lodash';
import React from 'react';

import { AttachmentType } from '@scale/shared/defaults';
import Image from './image';
import Text from './text';
import Video from './video';
import Audio from './audio';
import Website from './website';
import Mesh from './mesh';
import Pdf from './pdf';
import Pinterest from './pinterest';
import IFrame from './iframe';

const ensureUrlProtocol = function (url) {
  return (url || '').indexOf('://') === -1 ? 'http://' + url : url;
};

export default class Attachment extends React.Component<any> {
  render() {
    const type = this.props.attachmentType;
    const attachment = _.includes([AttachmentType.Text, AttachmentType.Pinterest], type)
      ? this.props.attachment
      : ensureUrlProtocol(this.props.attachment);
    const attachmentView = {
      [AttachmentType.Image]: (
        <Image
          keepOriginalDimensions={this.props.keepOriginalDimensions}
          imageDesc={this.props.attachmentDesc}
          key={attachment}
          imageUrl={attachment}
          onLoadOrError={this.props.onLoadOrError}
        >
          {this.props.children}
        </Image>
      ),
      [AttachmentType.Text]: (
        <Text key={attachment} text={attachment} onLoadOrError={this.props.onLoadOrError} />
      ),
      [AttachmentType.Video]: (
        <Video key={attachment} videoUrl={attachment} onLoadOrError={this.props.onLoadOrError} />
      ),
      [AttachmentType.Audio]: (
        <Audio key={attachment} audioUrl={attachment} onLoadOrError={this.props.onLoadOrError} />
      ),
      [AttachmentType.Website]: (
        <Website
          key={attachment}
          startingUrl={attachment}
          instruction={this.props.instruction}
          onOpenWebsite={this.props.onOpenWebsite}
        />
      ),
      [AttachmentType.PDF]: (
        <Pdf key={attachment} pdfUrl={attachment} onLoadOrError={this.props.onLoadOrError} />
      ),
      [AttachmentType.Pinterest]: <Pinterest attachmentJson={attachment} />,
      [AttachmentType.IFrame]: <IFrame iframeUrl={attachment} />,
      [AttachmentType.Mesh]: <Mesh {...this.props.task} />,
    }[type];

    if (!attachmentView) {
      return <div>Attachment type {type} not supported!</div>;
    }

    let attachmentLink = null;
    if (
      !_.includes(
        [
          AttachmentType.Text,
          AttachmentType.Website,
          AttachmentType.Pinterest,
          AttachmentType.IFrame,
          AttachmentType.JSON,
          AttachmentType.Mesh,
        ],
        type,
      )
    ) {
      attachmentLink = (
        <div className="task-attachment__header">
          <a target="_blank" rel="noopener noreferrer" href={attachment}>
            Open attachment link in new window
          </a>
        </div>
      );
    }

    return (
      <div className="task-attachment">
        <style jsx global>{`
          .task-attachment__item {
            width: 100%;
          }

          .task-attachment {
            margin: 24px;
            min-width: 200px;
            flex-grow: 1;
            width: 100%;
            height: 100%;
          }

          .task-attachment__item--embed {
            min-height: 600px;
          }

          .task-attachment__item--video {
            max-width: 920px;
          }

          .task-attachment__header {
            padding: 12px 0;
          }
        `}</style>

        {attachmentView}
        {attachmentLink}
      </div>
    );
  }
}
